var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('v-slide-x-reverse-transition',[_c('v-btn',{staticClass:"fetch-scores-button",attrs:{"loading":_vm.fetching,"large":"","rounded":""},on:{"click":_vm.fetchScores}},[_vm._v(" Sync Scores ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }